import Router from './_cores/_routes/router';

function App() {
  return (
    <div className="App">
      <Router />
    </div>
  ) 
}

export default App;
